export enum EntityType {
    Invoice = 'invoice',
    Checkout = 'checkout',
    Shipping = 'shipping',
    FinancialConnection = 'financial-connection',
    Order = 'order',
    Business = 'business',
    Email = 'email',
    Experian = 'experian',
    ExternalInvoice = 'external-invoice',
    ExternalShipping = 'external-shipping',
    Funds = 'funds',
    AirwallexTransfer = 'airwallex-transfer',
    AirwallexGlobalAccount = 'airwallex-global-account',
    Transaction = 'transaction',
}
